import React, {useEffect, useState} from "react";
import Clock from 'react-clock';
import './style.scss';
import 'react-clock/dist/Clock.css';
import {useSelector} from "react-redux";

import ContentSelector from "../../redux/reducers/contents/action";

function PerfWatchLog() {

    const totalPower = useSelector(ContentSelector.getTotalPower);

    const [value, setValue] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => setValue(new Date()), 1000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <div className='perf-watch-log'>
            <Clock value={value}/>
            <div className='p-2 w-100 text-center bg-primary mt-2 rounded text-white'><h5 className='m-0'><b>{totalPower}kW</b></h5></div>
        </div>
    );
}

export default PerfWatchLog;
